import React, { useEffect, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import apiClient from '../services/apiClient';
import { getApiBaseUrl } from '../config/api';

const appVersion = process.env.REACT_APP_VERSION;

interface FooterProps {
  showDisclaimer?: boolean;
}

const Footer: React.FC<FooterProps> = ({ showDisclaimer = false }) => {
  const { user } = useAuth();
  const [monthlyCost, setMonthlyCost] = useState<number | null>(null);
  const apiBase = getApiBaseUrl();

  const isAdmin =
    user?.is_superadmin ||
    user?.roles?.includes('ADMIN') ||
    user?.roles?.includes('SUPER_ADMIN');

  useEffect(() => {
    if (!isAdmin) return;

    apiClient
      .get(`${apiBase}/api/v1/billing/monthly-cost`)
      .then((res) => {
        setMonthlyCost(res.data.total_cost_usd ?? null);
      })
      .catch(() => {
        // 靜默失敗，不影響頁面
      });
  }, [isAdmin, apiBase]);

  const now = new Date();
  // 顯示金額加 10% 預算緩衝（DB 原始值不變）
  const costLabel =
    monthlyCost !== null
      ? `${now.getFullYear()} 年 ${now.getMonth() + 1} 月 Gemini API 費用累計：US$${(monthlyCost * 1.1).toFixed(2)}（僅供參考，請依實際帳單為準）`
      : null;

  return (
    <footer
      style={{
        textAlign: 'center',
        padding: '40px 20px 24px 20px',
        borderTop: '1px solid #e8e5df',
        background: '#faf8f5',
        fontSize: '14px',
        color: '#666',
      }}
    >
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        {showDisclaimer && (
          <p style={{ margin: '0 0 12px 0', fontSize: '15px', lineHeight: '1.6' }}>
            <strong>⚠️ AI 聲明：</strong>
            AI 審閱結果及意見可能存在錯誤，僅供參考，如有任何疑慮，正式發布前請務必諮詢貴公司法務。
          </p>
        )}
        {isAdmin && costLabel && (
          <p style={{ margin: '0 0 6px 0', fontSize: '12px', color: '#999' }}>
            {costLabel}
          </p>
        )}
        <p style={{ margin: 0, fontSize: '13px', color: '#999' }}>
          © 律果科技 LegalTech. All rights reserved.
          {appVersion && (
            <span style={{ marginLeft: 8, fontFamily: 'monospace' }}>| v{appVersion}</span>
          )}
        </p>
      </div>
    </footer>
  );
};

export default Footer;
